import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
// import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { SxProps } from "@mui/system";
import { Theme } from "@mui/material/styles";

dayjs.extend(utc);
dayjs.extend(timezone);

export default function CustomDateTimePicker({
  timezone,
  label,
  value,
  handleChange,
  sx,
  disabled = false,
  timeError,
}: {
  timezone: string;
  label: string;
  value: any;
  handleChange: any;
  disabled?: boolean;
  timeError?: string;
  sx?: SxProps<Theme>;
}) {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={"en"}>
      <TimePicker
        sx={sx}
        timezone={timezone}
        label={label}
        value={dayjs(value)}
        format="hh:mm A"
        onChange={handleChange}
        slotProps={{
          textField: {
            error: timeError ? true : false,
            helperText: timeError,
          },
        }}
        disabled={disabled}
        ampm={true}
      />
    </LocalizationProvider>
  );
}
